import type { Contact } from '@/api/types/contacts';

export const getFullName = (
  profile: Pick<Contact['profile'], 'titleBefore' | 'firstName' | 'lastName' | 'titleAfter'>,
  { includeTitle = true }: { includeTitle?: boolean } = {},
) =>
  [
    includeTitle ? profile?.titleBefore : undefined,
    profile?.firstName,
    profile?.lastName,
    includeTitle ? profile?.titleAfter : undefined,
  ]
    .filter(Boolean)
    .join(' ') || 'N/A';

export const getInitials = (profile: Pick<Contact['profile'], 'firstName' | 'lastName'>) =>
  ((profile?.firstName?.[0] || '') + (profile?.lastName?.[0] || '')).toUpperCase() || '?';

export const stringToColor = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return `hsl(${hash % 360}, 50%, 45%)`;
};
